/*
* @type 中国地图数据分布图
* @author xuyao
*/
import React, { PureComponent } from 'react';
import { colors, tooltipStyles } from './config/config';
import extend from './utils/extend';
import EchartBase from './base/EchartBase';

require('./china.js');

class BBDMapChinaDataRange extends PureComponent {
    constructor(props) {
        super(props);
    }
    setOption(param){
        let option = {
            title: {
                text: '',
                subtext: '',
                left: 'center'
            },
            tooltip: {
                trigger: 'item',
                padding: [5, 10, 5, 10],
                ...tooltipStyles
            },
            visualMap: {
                min: 0,
                max: 2500,
                left: 'left',
                top: 'bottom',
                itemWidth: 8,
                itemHeight: 80,
                text: ['高', '低'],
                calculable: false,
                inRange: {
                    color: ['#CAD7EA', '#2365C4']
                },
                textStyle: {
                    fontSize: 14,
                    color: colors.textColor
                }
            },
            toolbox: {
                show: false,
                orient: 'vertical',
                left: 'right',
                top: 'center',
                feature: {
                    dataView: {readOnly: false},
                    restore: {},
                    saveAsImage: {}
                }
            },
            series: [
                {
                    name: '数据分布',
                    type: 'map',
                    map: 'china',
                    roam: false,
                    label: {
                        show: true,
                        color: '#fff'
                    },
                    emphasis: {
                        itemStyle: {
                            areaColor: '#F99248'
                        },
                        label: {
                            show: true,
                            color: '#fff'
                        }
                    },
                    data: []
                }
            ]
        };
        let op = extend(true, {}, option, param);
        return op;
    }
    render() {
        return (
            <EchartBase onEvents={this.props.onEvents} option={this.setOption(this.props.option)} style = {this.props.style} />
        );
    }
}
export default BBDMapChinaDataRange;



// WEBPACK FOOTER //
// ./src/components/common/echarts/BBDMapChinaDataRange.jsx